import React, { useState } from "react";
import recolor_svg from "../../core/utils/recolor_svg";
import getSvgImgSrc from "../../core/utils/getSvgImgSrc";
import ConfirmDelete from "core/ui/confirm-delete";

function ListLocationTypes(props) {
  const { locationTypeList, deleteLocationType, editLocationType } = props;

  const [showModalDelete, setShowModalDelete] = useState(false);
  const [confirmDeleteText, setConfirmDeleteText] = useState(
    "Delete System Icon?"
  );
  const [iconToDelete, setIconToDelete] = useState(null);

  const onDeleteIconConfirmed = () => {
    deleteLocationType(iconToDelete);
    setShowModalDelete(false);
  };

  const onDeleteIconConfirmation = (i) => {
    setIconToDelete(i);
    setConfirmDeleteText(`Delete Location Type "${i.name}"?`);
    setShowModalDelete(true);
  };

  if (locationTypeList === undefined || locationTypeList.length === 0) {
    return (
      <div className="m-3">No Location Types to Display.</div>
    );
  }

  return (
    <>
      <ul className="icon-list-ul">
        {locationTypeList.map(function (locationType, i) {
          return (
            <li key={locationType.id}>
              <div>
                Icon:{" "}
                <img
                  height="25"
                  width="25"
                  alt="icon"
                  src={getSvgImgSrc(
                    recolor_svg(
                      locationType.svg,
                      locationType.color,
                      "currentColor"
                    )
                  )}
                />
                <span className="spacer"></span>
                Name: <strong>{locationType.name}</strong>
              </div>
              <div>
                Color:
                <span
                  className="color-sample"
                  style={{background: locationType.color}}
                ></span>
                <span className="spacer"></span>
                <span className="color-hex">
                  Hex: <strong>{locationType.color}</strong>
                </span>
                <div>
                </div>
              </div>
              <div className="list-btn-section">
                <button
                    disabled={locationType.in_use}
                    title={locationType.in_use ? "Location Type in use" : ""}
                    onClick={() => onDeleteIconConfirmation(locationType)}>
                  delete
                </button>
                <button onClick={() => editLocationType(locationType)}>
                  edit
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <ConfirmDelete
        show={showModalDelete}
        label={confirmDeleteText}
        proceed={onDeleteIconConfirmed}
        cancel={() => {
          setShowModalDelete(false);
        }}
      />
    </>
  );
}

export default ListLocationTypes;
